
const digest = '1945773877e6bcb04db45313c8a15dc8a099f97db29207dcf46b762b2aa41835';
const classes = {"wrapper":"_wrapper_1mvhd_1"};
const css = `._wrapper_1mvhd_1 {
  display: flex;
  flex-direction: row;
  gap: 5px;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  